import React, {Component} from 'react';
import Translate from "../../../../../components/Translate";
import InputText from "../../../../../components/input-text";
import {isPositiveInteger, silverInfoStyles} from "../../../../../utils/General";

const style = {
    wrapper: {
        display: "flex",
        margin: "15px",
        flexDirection: 'column'
    },
    inputWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: '76px',
        border: '1px solid #A4ADC1',
        height: '40px',
        width: '147px',
        borderRadius: '10px',
        marginTop: '10px'
    },
    inputStyle: {
        width: '95px',
        border: 'none',
        height: '38px'
    },
    divideDiv: {
        height: '34px',
        width: '0.5px',
        border: '0.5px solid #A4ADC1',
        top: '395px',
        left: '562px'
    },
    textDivStyle: {
        width: '32px',
        textAlign: 'center'
    }

};

class ExpireTimerPicker extends Component {
    constructor(props) {
        super(props);

        const {expiration} = this.props;

        this.state = {
            expireTime: expiration ? expiration.expireTime / 60 : 0,
            isExpirationEnabled: expiration ? expiration.enabled : false
        };

    }

    handleSwitchChange = () => {
        const isExpirationEnabled = this.state.isExpirationEnabled;
        const newValue = !isExpirationEnabled;

        this.setState({
            isExpirationEnabled: newValue
        });

        const {updateExpirationTime} = this.props;

        updateExpirationTime(
            this.state.expireTime * 60,
            newValue
        )
    };

    handleInputChange = (value) => {
        const {updateExpirationTime} = this.props;

        this.setState({
            expireTime: value
        });

        updateExpirationTime(
            value * 60,
            this.state.isExpirationEnabled
        )
    };

    validate = (value) => {
        isPositiveInteger(value);
        const parsedValue = Number(value);
        if (parsedValue < 1 || parsedValue > 60) {
            throw new Error('Wrong Range');
        }
    };

    render() {
        return (
            <div style={style.wrapper}>
                <h2 style={{fontSize: '16px', color: 'rgb(164, 173, 193)', marginBottom: '20px'}}>
                    <Translate text={'expireConfigs'}/>
                </h2>
                <div style={{display: "flex"}}>
                    <label className="switch controller">
                        <input type="checkbox"
                               checked={this.state.isExpirationEnabled}
                               onChange={this.handleSwitchChange}/>
                        <span className="slider round"/>
                    </label>
                    <h2 style={silverInfoStyles.info}>
                        <Translate text="enable/disable"/>
                    </h2>
                </div>

                {
                    this.state.isExpirationEnabled
                        ? <div style={{marginLeft: '74px', marginTop: '20px'}}>
                            <span style={{...silverInfoStyles.info, marginLeft: '0'}}>
                                <Translate text="expireDescription"/>
                            </span>
                            <div style={{...style.inputWrapper, marginLeft: '0'}}>
                                <InputText
                                    inputStyles={style.inputStyle}
                                    value={this.state.expireTime}
                                    validate={this.validate}
                                    handleChange={this.handleInputChange}
                                    defaultValue={this.state.expireTime}
                                />
                                <div style={style.textDivStyle}>
                                    <p><Translate text={'min'}/></p>
                                </div>
                            </div>
                        </div>
                        : <div/>
                }
            </div>
        )
    }
}

export default ExpireTimerPicker



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/ExpireTimerPicker.jsx